import React from "react"

function PuzzleSelector(props) {

    const puzzleOptions = props.puzzleData.map( (puzzle) => {
        if (puzzle.visible) {
            return <option key={puzzle.id} value={puzzle.name}>{puzzle.name}</option>
        } else {
            return ""
        }
    })
        
    return (
        <div>
            <label id="puzzleSelectLabel">Select The puzzle You Would Like A Hint For: <br />
                <select id="puzzles" value={props.selectedPuzzle} onChange={props.handleChange}>
                    {puzzleOptions}
                </select> 
            </label> <br />

            <button className="standardButton clueButton" onClick={props.newClue}>Request Hint</button>
            <button className="standardButton clueButton" onClick={props.prevClue}>Previous Hint</button>
        </div>
    )
}

export default PuzzleSelector